import {StyleSheet} from 'react-native';

import {bottomSpace} from '/constant/layout.constant';
import {chestnut} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  messageBanner: {
    position: 'absolute',
    zIndex: 1,
    elevation: 1,
    width: '100%',
    bottom: bottomSpace,
  },
  infoIcon: {
    color: chestnut,
    fontSize: 17,
    marginTop: 5,
  },
  messageText: {
    fontWeight: 'bold',
  },
});
